import { useEffect, useState } from "react";
import { api, errorText } from "@/lib/api";
import { PageTitle } from "./AdminOverview";
import { FormError } from "@/components/brand/Field";

export default function AdminAuditLog() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/admin/audit-log", { params: { limit: 200, action: filter || undefined } }).then((r) => setRows(r.data)).catch((e) => setErr(errorText(e)));
  }, [filter]);
  return (
    <>
      <PageTitle eyebrow="Trust" title="Audit log">
        <input className="ts-input h-9 w-64" placeholder="Filter by action, e.g. settings." value={filter} onChange={(e) => setFilter(e.target.value)} aria-label="Filter actions" data-testid="audit-filter-input" />
      </PageTitle>
      <FormError message={err} />
      <p className="text-xs mb-3" style={{ color: "var(--muted-text)" }}>Append-only. Entries cannot be edited or deleted from the console.</p>
      <div className="ts-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left eyebrow" style={{ background: "var(--paper)" }}><th className="p-3">When</th><th>Actor</th><th>Action</th><th>Details</th></tr></thead>
          <tbody data-testid="audit-table">
            {rows.map((r) => (
              <tr key={r.id} className="border-t align-top" style={{ borderColor: "var(--line-soft)" }}>
                <td className="p-3 num text-xs whitespace-nowrap">{r.created_at.slice(0, 19).replace("T", " ")}</td>
                <td className="text-xs"><span className="eyebrow">{r.actor_type}</span><div className="num" style={{ color: "var(--muted-text)" }}>{(r.actor_id || "—").slice(0, 8)}</div></td>
                <td className="num text-xs font-semibold">{r.action}</td>
                <td className="text-xs" style={{ color: "var(--muted-text)" }}>{r.reason && <div>Reason: {r.reason}</div>}<code className="break-all">{JSON.stringify(r.details)}</code></td>
              </tr>
            ))}
            {!rows.length && <tr><td className="p-4 text-sm" colSpan={4} style={{ color: "var(--muted-text)" }}>No entries match.</td></tr>}
          </tbody>
        </table>
      </div>
    </>
  );
}
